<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__content u-no-pt">
			<div class="o-media c-content u-no-pb u-ost-sm u-osb-xs">
				<div class="o-media__img">
					<div class="c-image c-image--bg c-image--round" [ngStyle]="{ 'background-image': 'url(' + (vm.user?.photoUrl ? vm.user?.photoUrl : vm.defaultProfilePicture) + ')' }"></div>
				</div>
				<div class="o-media__body">
					<p class="c-text c-text--gray">{{ 'Call.Title.Incoming_Call' | translate }}</p>
					<p class="c-text c-text--lg">{{ vm.user?.firstName }} {{ vm.user?.lastName }}</p>
				</div>
			</div>
		</div>
		<div class="c-modal__footer">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
					<button id="incomingCallDeclineButton" class="c-button c-button--s6 c-button--fit c-button--narrow" (click)="vm.decline()">{{ 'Call.Button.Decline' | translate }}</button>
				</div>
				<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
					<button id="incomingCallAcceptButton" class="c-button c-button--s1 c-button--fit c-button--narrow" (click)="vm.answer()">{{ 'Call.Button.Answer' | translate }}</button>
				</div>
			</div>
		</div>
		<audio preload="auto" loop id="call_ringtone" autoplay>
			<source src="https://dqs3afosyxqoy.cloudfront.net/assets/common/audio/call/ringtone.mp3" type="audio/mpeg" />
			<source src="https://dqs3afosyxqoy.cloudfront.net/assets/common/audio/call/ringtone.wav" type="audio/wav" />
		</audio>
	</div>
</div>
